/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { addNodeType } from "./kits.js";
const reservedWord = async () => {
    throw new Error("Reserved word handler should never be invoked");
};
// These get added to the default scope
const inputFactory = addNodeType("input", reservedWord);
const outputFactory = addNodeType("output", reservedWord);
export const base = {
    input: (config) => inputFactory(config),
    output: (config) => outputFactory(config),
};
//# sourceMappingURL=base.js.map